import Vue from 'vue'
import Vuex from 'vuex'
import invoiceModule from './modules/invoice'
import agreementModule from './modules/agreement'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 存放的键值对就是所要管理的状态
    name: ''
  },
  getters: {
    isFirstAccess: state => state.agreement.isFirstAccess
  },
  modules: {
    invoice: invoiceModule,
    agreement: agreementModule
  }
})
// 使用方法{{$store.state.name}}
export default store



// WEBPACK FOOTER //
// ./src/store/index.js